import { getAbsoluteNavigationPaths } from '../../utils/navigation';
import workCellSetupUrl from './docs/work-cell-setup.md?url';
import leaderStandardWorkUrl from './docs/leader-standard-work.md?url';

type HelpDocConfig = {
  title: string;
  url: string;
};

const {
  configurationMCellSetupPath,
  lswTaskPath,
  lswReportPath,
  lswConfigurationsPath,
} = getAbsoluteNavigationPaths();

const leaderStandardWorkDoc: HelpDocConfig = {
  title: 'Leader Standard Work Guide',
  url: leaderStandardWorkUrl,
};

/**
 * Maps route paths to their help documentation.
 * To add a new doc: import the .md file from docs/ and add an entry with the route path as the key.
 */
const helpDocs: Record<string, HelpDocConfig> = {
  [configurationMCellSetupPath]: {
    title: 'Work Cell Setup Guide',
    url: workCellSetupUrl,
  },
  [lswTaskPath]: leaderStandardWorkDoc,
  [lswReportPath]: leaderStandardWorkDoc,
  [lswConfigurationsPath]: leaderStandardWorkDoc,
};

export const getHelpDocConfig = (pathname: string): HelpDocConfig | undefined =>
  helpDocs[pathname];
